module.exports = __webpack_public_path__ + "img/cbl2r01-1.011f1033.gif";